import type { CatalogTree } from '../types';

export const products = {
  list: {
    note: 'Ürün verisi mağazanızdan gelir; burada yalnızca asistana özel alanlar düzenlenir.',
    table: 'Ürün listesi',
    columns: {
      product: 'Ürün',
      sku: 'SKU',
      price: 'Fiyat',
      stock: 'Stok',
      variant: 'Varyant',
      flags: 'Eksik veri',
      aiVisible: 'Asistana görünür',
    },
    noStore: 'Mağaza bağlı değil.',
    connectStore: 'Mağaza bağla',
    firstImport: 'İlk içe aktarma sürüyor…',
    noMatch: 'Bu filtreye uyan ürün yok.',
    noProducts: 'Henüz ürün yok.',
  },
  filters: {
    label: 'Ürün filtreleri',
    search: 'Ara',
    category: 'Kategori',
    flag: 'Eksik veri',
    anyFlag: 'Herhangi biri',
    flagCount: '{label} ({count})',
    aiVisible: 'Asistana görünür',
    yes: 'Evet',
    no: 'Hayır',
    availability: 'Stok',
    lifecycle: 'Durum',
    sort: 'Sırala',
    all: 'Tümü',
    sorts: {
      updated: 'Son değişiklik',
      title: 'Ada göre',
      price: 'Fiyata göre',
    },
  },
  lifecycle: {
    active: 'Aktif',
    draft: 'Taslak',
    archived: 'Arşiv',
    deleted: 'Mağazadan silindi',
  },
  detail: {
    notFound: 'Böyle bir ürün yok.',
    back: 'Ürünlere dön',
    storefront: 'Mağazada aç',
    aiVisible: 'Asistana görünür',
    images: 'Görseller',
    imageUnavailable: 'Görsel alınamadı',
    description: 'Açıklama',
    variants: 'Varyantlar',
    variantTable: 'Varyant listesi',
    columns: {
      variant: 'Varyant',
      sku: 'SKU',
      prices: 'Fiyat',
      stock: 'Stok',
      confirmedAt: 'Onay zamanı',
    },
    paymentMethod: {
      bank_transfer: 'Havale/EFT',
      card: 'Kart',
      cash_on_delivery: 'Kapıda ödeme',
      other: 'Diğer',
    },
    listPrice: 'Liste fiyatı',
    madeToOrder: 'Siparişe özel üretim: {days} gün',
    variantAttributes: 'Varyant özellikleri',
    attributes: 'Kuyumcu özellikleri',
    overridesNote: "Düzeltmeler yalnızca ESNAF AI'da saklanır; mağazanıza yazılmaz.",
    aiNote: 'Asistan notu',
    aiNotePlaceholder: 'Örn. Siparişe özel üretilir, 3 gün',
    save: 'Kaydet',
    linkedContent: 'Bağlı Instagram içerikleri',
    linkContent: 'İçerik bağla',
  },
  attribute: {
    yes: 'Evet',
    no: 'Hayır',
    source: {
      platform: 'Mağazadan',
      native: 'Mağazadan',
      extracted: 'Tahmini ({confidence})',
      extractedPlain: 'Tahmini',
      merchant_override: 'Personel düzeltmesi',
    },
    platformValue: 'Platform değeri: {value}',
    platformChanged: 'Platform değeri değişti: {value}',
    edit: 'Düzelt',
    remove: 'Düzeltmeyi kaldır',
  },
  override: {
    title: 'Düzelt: {label}',
    save: 'Kaydet',
    intRequired: 'Tam sayı girin.',
    decimalRequired: 'Sayı girin (örn. 3,25).',
  },
  contentLink: {
    title: 'İçerik bağla',
    content: 'İçerik',
    submit: 'Bağla',
  },
  sync: {
    lastSync: 'Son eşitleme: {time}',
    pricesRead: 'Fiyatlar son okundu: {time}',
    errors: '{count} hata',
    log: 'Günlüğü gör',
    syncNow: 'Şimdi eşitle',
    alreadyRunning: 'Eşitleme zaten sürüyor',
    keepsAnswering: 'Yanıtlar kayıtlı kopyadan verilmeye devam eder.',
  },
} as const satisfies CatalogTree;
